/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var RotateSquareLeftIcon20Light = forwardRef('RotateSquareLeftIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.188.11a.5.5 0 1 1 .624.78L11.425 2H15a4 4 0 0 1 4 4v2.5a.5.5 0 0 1-1 0V6a3 3 0 0 0-3-3h-3.575l1.387 1.11a.5.5 0 1 1-.624.78l-1.67-1.336a1.35 1.35 0 0 1 0-2.108L12.187.11Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 10a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-6Zm-3-2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h6Z" })));
});
